import numberUtils from './numberUtils';

import type { UserClaimListItemWebDto } from '@zg-rentals/ts-rental-manager-api-client';

const { cleanPhoneNumber } = numberUtils;

type contactMethodsType = {
  emails: Array<{ value: string } | string>;
  phones: Array<{ value: string } | string>;
};

export const isEmailInContactMethods = (contactMethods: contactMethodsType, listingEmail: string | undefined) =>
  listingEmail !== undefined &&
  contactMethods.emails.some((contact) => {
    if (typeof contact === 'string') {
      return contact === listingEmail;
    } else {
      return contact.value === listingEmail;
    }
  });

export const isPhoneInContactMethods = (contactMethods: contactMethodsType, listingPhone: string | undefined) =>
  listingPhone !== undefined &&
  contactMethods.phones
    .map((phoneNumber) => {
      if (typeof phoneNumber === 'string') {
        return cleanPhoneNumber(phoneNumber);
      } else {
        return cleanPhoneNumber(phoneNumber.value);
      }
    })
    .includes(cleanPhoneNumber(listingPhone));

export const getContactType = (contact: { value: string }) => (isNaN(parseInt(contact.value, 10)) ? 'email' : 'phone');

export const getVerifiedContacts = (combinedContactMethods: Array<{ isVerified: boolean }>) =>
  combinedContactMethods.some((contactMethod) => contactMethod.isVerified);

export const combineContactMethods = ({
  emails,
  phones,
}: {
  emails: Array<UserClaimListItemWebDto>;
  phones: Array<UserClaimListItemWebDto>;
}) => [...emails, ...phones].sort((a, b) => (a.isVerified ? -1 : 1) - (b.isVerified ? -1 : 1));

export const getConversionRate = ({ failed, succeeded, total }: { [key: string]: number }) =>
  ((failed + succeeded) / total) * 100;
